import { create } from 'zustand'

interface UiState {
  /** Coral dot on the Chat tab; intentionally a boolean, not a count. */
  chatUnread: boolean
  /** Deep link preserved through auth and cleared after join/logout. */
  pendingActivityPath: string | null
  setChatUnread: (unread: boolean) => void
  setPendingActivityPath: (path: string | null) => void
  resetUiState: () => void
}

/**
 * Ephemeral UI state only (D-042). Server data stays in the route loader and
 * the backend; this store must never hold API response caches.
 */
export const useUiStore = create<UiState>()((set) => ({
  chatUnread: false,
  pendingActivityPath: null,
  setChatUnread: (chatUnread) => set({ chatUnread }),
  setPendingActivityPath: (pendingActivityPath) =>
    set({ pendingActivityPath }),
  resetUiState: () => set({ chatUnread: false, pendingActivityPath: null }),
}))
